const appDetails = {
    webLink: "https://rosendalefarms.graindiscovery.com",
    googlePlayLink: "",
    appStoreLink: "",
    landingPage: "cashbids",
    signUpButton: false
}

export default appDetails;